import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { SvgScalable } from '../SvgScalable';
import * as React from 'react';
import { Component } from 'react';
import { Change } from './components/Change';
import { Line } from './components/Line';
import { Station } from './components/Station';
import * as style from './UndergroundMapV1.css';
export var UndergroundMapV1 = /*#__PURE__*/function (_Component) {
  _inherits(UndergroundMapV1, _Component);

  var _super = _createSuper(UndergroundMapV1);

  function UndergroundMapV1(props) {
    var _this;

    _classCallCheck(this, UndergroundMapV1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onHoverHandler", function (ids) {
      _this.setState({
        hoveredStationsIds: ids
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onLeaveHandler", function () {
      _this.setState({
        hoveredStationsIds: []
      });
    });

    _this.state = {
      hoveredStationsIds: []
    };
    return _this;
  }

  _createClass(UndergroundMapV1, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var lines = this.props.data.lines.map(function (line) {
        return /*#__PURE__*/React.createElement(Line, {
          data: line,
          key: line.id,
          onSelect: _this2.props.onSelect,
          onRemove: _this2.props.onRemove,
          onHover: _this2.onHoverHandler,
          onLeave: _this2.onLeaveHandler,
          selectedIds: _this2.props.selectedStations
        });
      });
      var changes = this.props.data.changes.map(function (change, index) {
        return /*#__PURE__*/React.createElement(Change, {
          data: change,
          key: index
        });
      });
      var stations = [];
      var data = this.props.data.stations;

      var _loop = function _loop(value) {
        if (data.hasOwnProperty(value)) {
          stations.push( /*#__PURE__*/React.createElement(Station, {
            data: data[value],
            key: data[value].id,
            onSelect: _this2.props.onSelect,
            onRemove: _this2.props.onRemove,
            isSelected: _this2.isSelected(data[value].id),
            onHover: _this2.onHoverHandler,
            onLeave: _this2.onLeaveHandler,
            isHovered: _this2.state.hoveredStationsIds.some(function (id) {
              return id === Number(data[value].id);
            })
          }));
        }
      };

      for (var value in data) {
        _loop(value);
      }

      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "map-v1",
        className: style['metro'],
        style: {
          width: "".concat(this.props.data.width, "px")
        }
      }, /*#__PURE__*/React.createElement(SvgScalable, {
        viewBox: this.props.data.viewBox,
        width: "100%"
      }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
        id: "metroStationBlur",
        x: "-5",
        y: "-5",
        width: "20",
        height: "20"
      }, /*#__PURE__*/React.createElement("feGaussianBlur", {
        in: "SourceGraphic",
        stdDeviation: "2"
      }))), lines, changes, stations));
    }
  }, {
    key: "isSelected",
    value: function isSelected(id) {
      return this.props.selectedStations.some(function (value) {
        return value === Number(id);
      });
    }
  }]);

  return UndergroundMapV1;
}(Component);